/**
 * Read an image file and resize it to a small thumbnail data URL (WebP), so what
 * we store and send stays tiny regardless of the source photo's size. Shared by
 * the tenant and vendor furniture editors.
 */
export async function fileToThumbnail(file: File, max = 256): Promise<string> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(new Error('Could not read that file.'))
    reader.readAsDataURL(file)
  })
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error('That file is not a readable image.'))
    image.src = dataUrl
  })
  const scale = Math.min(1, max / Math.max(img.width, img.height))
  const width = Math.max(1, Math.round(img.width * scale))
  const height = Math.max(1, Math.round(img.height * scale))
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Image resizing is not supported in this browser.')
  ctx.drawImage(img, 0, 0, width, height)
  return canvas.toDataURL('image/webp', 0.82)
}
